import { render, staticRenderFns } from "./void-quote.vue?vue&type=template&id=455e8531&scoped=true&"
import script from "./void-quote.vue?vue&type=script&lang=js&"
export * from "./void-quote.vue?vue&type=script&lang=js&"
import style0 from "./void-quote.vue?vue&type=style&index=0&id=455e8531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455e8531",
  null
  
)

export default component.exports